<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>
    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">
          <div class="col-12">
            <button routerLink="/createcompany" style="margin-left: 0;" class="first-btn btn btn-primary">
              انشاء شركة
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->
            <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="ابحث بالاسم او التخصص او الهاتف او الايميل" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef>{{ 'address' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.address }}</td>
            </ng-container>
            <ng-container matColumnDef="tel">
              <th mat-header-cell *matHeaderCellDef>{{ 'Phone Number' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.tel }}
              </td>
            </ng-container>
            <ng-container matColumnDef="specialty">
              <th mat-header-cell *matHeaderCellDef>التخصص</th>
              <td mat-cell *matCellDef="let el">{{ el.specialty }}</td>
            </ng-container>
            <ng-container matColumnDef="industry">
              <th mat-header-cell *matHeaderCellDef>القطاع</th>
              <td mat-cell *matCellDef="let el">{{ el.industry }}</td>
            </ng-container>
            <ng-container matColumnDef="fax">
              <th mat-header-cell *matHeaderCellDef>فاكس</th>
              <td mat-cell *matCellDef="let el">{{ el.fax }}</td>
            </ng-container>
            <ng-container matColumnDef="facebook">
              <th mat-header-cell *matHeaderCellDef>فيسبوك</th>
              <td mat-cell *matCellDef="let el">{{ el.facebook }}</td>
            </ng-container>
            <ng-container matColumnDef="linkedin">
              <th mat-header-cell *matHeaderCellDef>انستجرام</th>
              <td mat-cell *matCellDef="let el">{{ el.linkedin }}</td>
            </ng-container>
            <ng-container matColumnDef="add_by">
              <th mat-header-cell *matHeaderCellDef>أضيف بواسطة</th>
              <td mat-cell *matCellDef="let el">{{ el.add_by }}</td>
            </ng-container>
            <ng-container matColumnDef="editor">
              <th mat-header-cell *matHeaderCellDef>تم التعديل</th>
              <td mat-cell *matCellDef="let el">
                <ng-container *ngIf="el.editors?.length">
                  <span *ngFor="let editor of el.editors; let i = index">
                    {{ editor }}<br> 
                  </span>
                </ng-container>
                <span *ngIf="!el.editors?.length">-</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="is_ahmed_elshahat_client">
              <th mat-header-cell *matHeaderCellDef>عميل احمد الشحات</th>
              <td mat-cell *matCellDef="let el">
                <span *ngIf="el.is_ahmed_elshahat_client; else noKsa">✔</span>
                <ng-template #noKsa>✖</ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="contact_email">
              <th mat-header-cell *matHeaderCellDef>{{ 'Email' | translate }}</th>
              <td mat-cell *matCellDef="let el">
                {{ el.contact_email }}
              </td>
            </ng-container>
            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a class="dropdown-item" (click)='edit(element)'>
                        {{ "Edit" | translate }} </a></li>
                    @if(isAdmin){
                    <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" | translate }}</a></li>
                    }
                  </ul>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator
            style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
            [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>
        </div>
        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>